<div class="rp-dialog">
  <div class="rp-header">
    <div class="rp-header-main">
      <mat-icon class="rp-header-icon">manage_accounts</mat-icon>
      <h2 class="rp-title">Ressourcenplanung verwalten</h2>
    </div>
    <button mat-icon-button class="rp-close" (click)="close()" matTooltip="Schließen">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="admin-content">
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

    <!-- Kategorien -->
    <section class="rp-section">
      <div class="rp-section-head"><mat-icon>label</mat-icon><span>Kategorien</span></div>
      <div class="skill-list">
    <div class="skill-row" *ngFor="let c of categories">
      <input class="color-input" type="color" [(ngModel)]="c.color" />
      <input class="skill-name" [(ngModel)]="c.name" />
      <label class="absence-toggle" matTooltip="Zählt als Abwesenheit (z.B. Urlaub) – reduziert die Auslastungskapazität">
        <mat-checkbox [(ngModel)]="c.countsAsAbsence" color="primary"></mat-checkbox>
        Abwesenheit
      </label>
      <button mat-icon-button color="primary" (click)="saveCategory(c)" matTooltip="Speichern">
        <mat-icon>save</mat-icon>
      </button>
      <button mat-icon-button color="warn" (click)="deleteCategory(c)" matTooltip="Löschen">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    <div class="skill-row new">
      <input class="color-input" type="color" [(ngModel)]="newCatColor" />
      <input class="skill-name" placeholder="Neue Kategorie…" [(ngModel)]="newCatName"
             (keyup.enter)="addCategory()" />
      <label class="absence-toggle">
        <mat-checkbox [(ngModel)]="newCatAbsence" color="primary"></mat-checkbox>
        Abwesenheit
      </label>
      <button mat-icon-button color="primary" (click)="addCategory()" matTooltip="Hinzufügen">
        <mat-icon>add</mat-icon>
      </button>
    </div>
      </div>
    </section>

    <!-- Skills -->
    <section class="rp-section">
      <div class="rp-section-head"><mat-icon>psychology</mat-icon><span>Skills / Können</span></div>
      <div class="skill-list">
    <div class="skill-row" *ngFor="let s of skills">
      <input class="color-input" type="color" [(ngModel)]="s.color" />
      <input class="skill-name" [(ngModel)]="s.name" />
      <button mat-icon-button color="primary" (click)="saveSkill(s)" matTooltip="Speichern">
        <mat-icon>save</mat-icon>
      </button>
      <button mat-icon-button color="warn" (click)="deleteSkill(s)" matTooltip="Löschen">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    <div class="skill-row new">
      <input class="color-input" type="color" [(ngModel)]="newSkillColor" />
      <input class="skill-name" placeholder="Neuer Skill…" [(ngModel)]="newSkillName"
             (keyup.enter)="addSkill()" />
      <button mat-icon-button color="primary" (click)="addSkill()" matTooltip="Hinzufügen">
        <mat-icon>add</mat-icon>
      </button>
    </div>
      </div>
    </section>

    <!-- Planbare Benutzer -->
    <section class="rp-section">
      <div class="rp-section-head"><mat-icon>groups</mat-icon><span>Planbare Mitarbeiter</span></div>

  <div class="add-user-row">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="add-user-field">
      <mat-label>Mitarbeiter hinzufügen</mat-label>
      <mat-select [(ngModel)]="userToAdd">
        <mat-option *ngFor="let u of addableUsers" [value]="u.id">
          {{ u.name }}<span *ngIf="u.email"> ({{ u.email }})</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-stroked-button color="primary" [disabled]="!userToAdd" (click)="addUser()">
      <mat-icon>person_add</mat-icon> Hinzufügen
    </button>
    <span class="addable-hint" *ngIf="addableUsers.length === 0 && !loading">Alle Benutzer sind bereits planbar.</span>
  </div>

  <table class="user-table" *ngIf="plannableUsers.length">
    <thead>
      <tr>
        <th>Mitarbeiter</th>
        <th>Kapazität (h/Woche)</th>
        <th>Skills</th>
        <th>Kalender-Link (iCal/ICS)</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let u of plannableUsers">
        <td>
          <div class="u-name">{{ u.name }}</div>
          <div class="u-mail">{{ u.email }}</div>
        </td>
        <td class="center">
          <input class="cap-input" type="number" min="0" max="80" [(ngModel)]="u.weeklyCapacityHours" />
        </td>
        <td>
          <mat-form-field appearance="outline" class="skill-select-field" subscriptSizing="dynamic">
            <mat-select multiple [(ngModel)]="u.skillIds" placeholder="—">
              <mat-option *ngFor="let s of skills" [value]="s.id">
                <span class="cat-dot" [style.background]="s.color"></span>{{ s.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
        <td>
          <input class="feed-input" type="url" placeholder="https://…/calendar.ics"
                 [(ngModel)]="u.calendarFeedUrl" />
        </td>
        <td class="center actions">
          <button mat-stroked-button color="primary" (click)="saveUser(u)" [disabled]="u.saving">Speichern</button>
          <button mat-icon-button color="warn" (click)="removeUser(u)" matTooltip="Aus Planung entfernen">
            <mat-icon>person_remove</mat-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <p *ngIf="!loading && plannableUsers.length === 0" class="empty">
    Noch keine planbaren Mitarbeiter. Oben jemanden hinzufügen.
  </p>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions class="rp-actions">
    <span class="rp-spacer"></span>
    <button mat-flat-button color="primary" (click)="close()">Schließen</button>
  </mat-dialog-actions>
</div>
